import * as React from 'react';
import { connect } from 'react-redux';
import * as uuid from 'uuid';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Dialog from '@material-ui/core/Dialog';

import { FLYBITS } from '../constants';
import { isLoginRequested } from '../utils/authentication';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class Login extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Dialog
                    open={isLoginRequested(this.props.authentication)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <ClickAwayListener onClickAway={this.props.onClose}>
                        <Button color="primary" onClick={this.doLoginFlybits} >Sign in with Flybits</Button>
                        <Button color="primary" disabled={true}>Sign in with Channel Partners</Button>
                        <Button color="primary" onClick={this.doGetCertified} >Partner with us | Get Certified</Button>
                    </ClickAwayListener>
                </Dialog>
            </div>
        );
    }
    private doLoginFlybits = async () => {
        const clientId = 'production' === process.env.NODE_ENV ? FLYBITS.WEB_CLIENT_ID : 'localhost-client'
        const pnsHost = 'production' === process.env.NODE_ENV ? FLYBITS.WEB_HOST : 'http://localhost:3000'
        window.location.href = `${FLYBITS.IDP_HOST}/auth/authorize?client_id=${clientId}&redirect_uri=${pnsHost}/auth/implicit/callback&response_type=id_token%20token&scope=openid%20profile&nonce=${uuid.v4()}`
    }
    private doGetCertified = async () => {
        window.open (`${FLYBITS.SANDBOX_HOST}/welcome`)
    }
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(Login));



// WEBPACK FOOTER //
// ./src/components/login-options.tsx